/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const SheetTransformConfig = core.serialization.object({
    sourceSheetIds: core.serialization.list(core.serialization.string()),
    destinationSheetIds: core.serialization.list(core.serialization.string()),
});
